module.exports = __webpack_public_path__ + "img/arrow_down.ee239e11.svg";